import { MaskPathAndBrushData } from 'js/types';

const MASK_DATA_MEMORY_CACHE = new Map<string, Array<MaskPathAndBrushData>>();

export const getMemoryCache = () => {
  return MASK_DATA_MEMORY_CACHE;
};
